export default __webpack_public_path__ + "static/media/sem-adesao.9f7a1086.svg";